import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const PageHeader = styled.div`
    margin-top: ${getPurpurSpacing('100')};
    margin-bottom: ${getPurpurSpacing('200')};
    ${purpurMedia('lg')`
        margin-top: ${getPurpurSpacing('200')};
        margin-bottom: ${getPurpurSpacing('300')};
    `};
`;

export const GoBackContainer = styled.div`
    margin-bottom: ${getPurpurSpacing('100')};
    ${purpurMedia('lg')`
        margin-bottom: ${getPurpurSpacing('200')};
    `};
`;
